var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 33.9168C27.0143 33.9168 33.9166 27.0146 33.9166 18.5002C33.9166 9.98577 27.0143 3.0835 18.4999 3.0835C9.98553 3.0835 3.08325 9.98577 3.08325 18.5002C3.08325 27.0146 9.98553 33.9168 18.4999 33.9168Z",
    fill: "#EA872D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 12.3335V18.5002M18.4999 24.6668H18.5153M33.9166 18.5002C33.9166 27.0146 27.0143 33.9168 18.4999 33.9168C9.98553 33.9168 3.08325 27.0146 3.08325 18.5002C3.08325 9.98577 9.98553 3.0835 18.4999 3.0835C27.0143 3.0835 33.9166 9.98577 33.9166 18.5002Z",
    stroke: "#FFF6ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastWarningIcon);
export default __webpack_public_path__ + "static/media/toast-warning-icon.bbffa73924b97c27d98d5879ee1c6221.svg";
export { ForwardRef as ReactComponent };